import { render } from "./leydocumento.vue?vue&type=template&id=506a6d66&scoped=true"
import script from "./leydocumento.vue?vue&type=script&lang=js"
export * from "./leydocumento.vue?vue&type=script&lang=js"

import "./leydocumento.vue?vue&type=style&index=0&id=506a6d66&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506a6d66"]])

export default __exports__